module.exports = __webpack_public_path__ + "img/sv20.0935f34c.svg";